<div class="page-content-main box-panel shadow max-w max-gs pt-5 mt-5" id="page-content-main">
  <div class="container m--full-bleed">
    <div class="form-display-card">
      <mat-card class='mat-card-display mb-4 pt-5'>
        <mat-card-header>
          <mat-card-title class="justify-content-right">
            <h2 class="mat-card-title align-items-start">
              <span class="fa fa-credit-card fa-md-black mr-2"></span> Credit Card Payment Cancelled
            </h2>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row justify-content-center">
            <p>Your payment attempt has been cancelled. The information was not saved.</p>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="t-alignC pt-2 pb-2">
        <button class="btn" (click)="GoToHomePage()">Home</button>
      </div>
    </div>
  </div>
</div>
